import InboxOutlined from '@ant-design/icons/InboxOutlined';
import App from 'antd/lib/app';
import { Upload } from 'antd/lib';
import Dragger from 'antd/lib/upload/Dragger';
import type { UploadProps } from 'antd';
import { useImportContext } from '../ImportProvider';

type FileType = '.csv' | '.xlsx' | '.xls';

interface ImportUploadZoneProps {
    acceptFileType: FileType;
}

export const ImportUploadZone = ({ acceptFileType }: ImportUploadZoneProps) => {
    const { notification } = App.useApp();
    const { onFileLoad, onFileRemove } = useImportContext();

    const uploadProps: UploadProps = {
        accept: acceptFileType,
        multiple: false,
        maxCount: 1,
        onRemove: file => {
            onFileRemove();
        },
        beforeUpload: file => {
            if (!file.name.toLowerCase().endsWith(acceptFileType)) {
                notification.warning({
                    key: 'upload-file-type-notification',
                    message: `Please select "${acceptFileType}" file.`,
                });

                return Upload.LIST_IGNORE;
            }

            onFileLoad(file);

            return false;
        },
    };

    return (
        <Dragger {...uploadProps} key="import-upload-zone-dragger">
            <p className="ant-upload-drag-icon">
                <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click here or drag file to this area</p>
            <p className="ant-upload-hint">Allowed file extensions: {acceptFileType}</p>
        </Dragger>
    );
};
